<template>
  <div @click="onClick">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {};
  },
  methods: {
    onClick(e: Event) {
      if (e.target instanceof HTMLAnchorElement) {
        e.preventDefault();
        this.$router.push(e.target.getAttribute("href") || "");
      }
    },
  },
});
</script>
